import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "../analytics.js";

/**
 * Fires a `page_view` event on every client-side route change. Firebase
 * Analytics' automatic page_view only fires once at SDK init, so a
 * single-page app's route changes need an explicit call — otherwise every
 * screen after the first is invisible to GA4.
 */
export function usePageViewTracking(): void {
  const location = useLocation();

  useEffect(() => {
    trackEvent("page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
    });
  }, [location.pathname, location.search]);
}
